import React, { ReactNode } from 'react';
import { GiWaterSplash } from "react-icons/gi";

interface WatermarksProps {
    children: ReactNode;
}
const Watermarks: React.FC<WatermarksProps> = (props) => {
    return (
        <div className="relative w-full h-[80vh]">
            <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center opacity-10">
                <div className="flex flex-col items-center">
                    <GiWaterSplash className="text-green-600 text-9xl mb-2 select-none" />
                    <h1 className="text-gray-600 text-sm sm:text-2xl 2xl:text-2xl font-bold select-none">Developed by Preface Technology PVT LTD</h1>
                    <h6 className='text-gray-600 font-semibold'>Butwal-13, Rupandehi</h6>
                    <h6 className='text-gray-600 font-semibold text-[10px]'>071-445564, 9857079054</h6>

                </div>
            </div>
            <div className="relative z-10">
                {props.children}
            </div>
        </div>
    );
}

export default Watermarks;
